// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"BatchCreditOnsCheck__infoRow--1Cv7OddKed-4vX4zOmm-Em"};